module.exports = __webpack_public_path__ + "static/media/next-blue.a164041b.svg";